import React, { useEffect, useContext, useState } from 'react';
import styled from 'styled-components';
import ENDPOINT from '../../../globals/api-endpoint';
import { AuthContext } from '../../../contexts/AuthContext';
import { Redirect } from 'react-router-dom';

const ServiceForm = styled.form`
	text-align: left;
	margin: 0 auto;
	padding: 0 20px;
	max-width: 700px;
`;

const ServiceFormContainer = styled.div`
	margin: 50px auto;
	text-align: center;
	padding : 20px;
	border: 1px solid ${props => props.theme.green};
	border-radius: 5px;
	max-width: 600px;
`;

const Input = styled.input`
	color : white;
	background: ${props => props.theme.purple};
	font-size : 16px;
	border: 2px solid ${props => props.theme.purple};
	border-radius: 5px;
	text-align : center;
	margin: 5px;
	font-family: 'sans-serif';
	padding: 5px;
	transition: all 0.5s;
	&:hover {
		background: white;
		color : ${props => props.theme.purple};
		cursor: pointer;
	}
`;

const H3 = styled.h3`
	margin-bottom: 10px;
`;

const WarningStyled = styled.p`
	color: red;
`;

const InputStyled =styled.input`
	font-size : 14px;
	border: 2px solid ${props => props.theme.purple};
	border-radius: 5px;
	text-align : left;
	margin: 5px;
	font-family: 'sans-serif';
	padding: 5px;
	transition: all 0.5s;
`;

const InputContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
`;

const NewService = (props) => {
	const [categories, setCategories] = useState([]);
	const [newService, setNewService] = useState({
		name: '',
		price: '',
		categoryId: '',
		description: '',
		user: '',
		demo: '',
	});
	const [failed, setFailed] = useState(false);

	useEffect(() => {
	  window.scrollTo(0, 0)
	}, []);

	useEffect(() => {
		fetch(ENDPOINT.GET_ALL_CAT)
		.then(res => res.json())
		.then(res => {
			setCategories(res.categories);
			const newCategory = res.categories[0]._id;
			setNewService((prevServ) => ({
				...prevServ,
				categoryId: newCategory
			}));
		})
		.catch(err => console.log(err))
	}, [])

	const { auth, dispatch } = useContext(AuthContext);
	const [token, setToken] = useState({
		authToken: localStorage.getItem('authToken')
	});
	const [isLoading, setIsLoading] = useState(true);
	const localToken = JSON.parse(token.authToken);
	const tokenFromStorage = localToken ? (localToken.token) : (null);

	useEffect(() => {
		setToken({
			authToken: localStorage.getItem('authToken')
		});
	}, []);

	useEffect(() => {
		const fetchData = () => { 
			setIsLoading(true);
			fetch(ENDPOINT.CHECK_AUTH, {
				headers: {
					Authorization: tokenFromStorage
				}
			})
			.then(res => res.json())
			.then(res => {
				if (res.message === 'Auth succesful') {
					dispatch({ type: 'SWITCH_AUTH', auth: true,  uid: res.userId });
					setNewService((prevServ) => ({
						...prevServ,
						user: res.userId
					}));
				} else {
					dispatch({ type: 'SWITCH_AUTH', auth: false });
					return <Redirect to={'/me'} />
				}
			})
			.catch(err => {
				console.log(err);
			})
			.finally(res => {
				setIsLoading(false);
			});
		}
		fetchData();
	}, [dispatch, tokenFromStorage]);

	const categorySelection = categories.map(cat => {
		return <option key={cat._id} value={cat._id}>{cat.name}</option>
	});

	const handleSelectCategory = (newCategory) => {
		setNewService((prevServ) => ({
			...prevServ,
			categoryId: newCategory
		}));
	}

	const handleNameChange = (newName) => {
		setNewService((prevServ) => ({
			...prevServ,
			name: newName
		}));
	}

	const handlePriceChange = (newPrice) => {
		setNewService((prevServ) => ({
			...prevServ,
			price: newPrice
		}));
	}

	const handleDescChange = (newDesc) => {
		setNewService((prevServ) => ({
			...prevServ,
			description: newDesc
		}));
	}

	const handleDemoChange = (newDemo) => {
		setNewService((prevServ) => ({
			...prevServ,
			demo: newDemo
		}));
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		setIsLoading(true);
		fetch(ENDPOINT.ALL_SERVICES,{
			method : 'POST',
			headers : {
				'Authorization' : tokenFromStorage,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(newService)
		})
		.then(res => res.json())
		.then(res => {
			if (res.message === 'Service created') {
				setFailed(false);
				props.history.push('/me');
			} else {
				setFailed(true);
			}
		})
		.catch(err => console.log(err))
		.finally(res => {
			setIsLoading(false);
		})
	}

	if (auth.isAuth === false) {
		return <Redirect to={'/login'} />
	}

	if (isLoading) {
		return(
			<div className="loading">
				<div className="sk-folding-cube">
				  <div className="sk-cube1 sk-cube"></div>
				  <div className="sk-cube2 sk-cube"></div>
				  <div className="sk-cube4 sk-cube"></div>
				  <div className="sk-cube3 sk-cube"></div>
				</div>
			</div>
		);
	} else {
		return(
			<ServiceFormContainer>
				<H3>Buat layanan baru</H3>
				<ServiceForm onSubmit={handleSubmit}>
					<InputContainer>
							<label htmlFor="name">Nama layanan :</label>
							<InputStyled placeholder="mis. Jasa Pembuatan Logo" type="text" value={newService.name} onChange={(e) => handleNameChange(e.target.value)}/>
						</InputContainer>
						<InputContainer>
							<label htmlFor="price">Harga :</label>
							<InputStyled placeholder="Harga jasa anda" type="number"  value={newService.price} onChange={(e) => handlePriceChange(e.target.value)}/>
						</InputContainer>
						<InputContainer>
							<label htmlFor="category">Kategori :</label>
							<select value={newService.category} onChange={(e) => handleSelectCategory(e.target.value)}>
								{ categories.length > 0 ? (categorySelection) : (null) }
							</select>
						</InputContainer>
						<InputContainer>
							<label htmlFor="description">Deskripsi :</label>
							<textarea name="description" id="" cols="30" rows="5" value={newService.description} onChange={(e) => handleDescChange(e.target.value)}></textarea>
						</InputContainer>
						<InputContainer>
							<label htmlFor="demo">Link demo :</label>
							<InputStyled value={newService.demo} onChange={(e) => handleDemoChange(e.target.value)} />
						</InputContainer>
						<Input type="submit" value="Buat"/>
				</ServiceForm>
				{ failed ? (<WarningStyled>Gagal menambahkan data</WarningStyled>) : (null) }
			</ServiceFormContainer>
		);
	}
}

export default NewService;